package br.com.vvrefeicoes.portal.core.util

import kotlin.math.abs

object MoneyFormatter {
    fun formatCents(cents: Long?): String {
        if (cents == null) return ""
        val reais = abs(cents) / 100
        val centavos = abs(cents) % 100
        val body = "${groupThousands(reais.toString())},${centavos.toString().padStart(2, '0')}"
        return if (cents < 0) "-$body" else body
    }

    fun formatNumber(value: Long): String {
        val body = groupThousands(abs(value).toString())
        return if (value < 0) "-$body" else body
    }

    fun parseReaisToCents(text: String): Long? {
        val trimmed = text.trim()
        if (trimmed.isEmpty()) return null
        val negative = trimmed.contains("-")
        val withoutGrouping = trimmed.replace("-", "").replace(".", "")
        if (withoutGrouping.isEmpty()) return null
        val commaIndex = withoutGrouping.indexOf(',')
        val integerPart = if (commaIndex >= 0) withoutGrouping.substring(0, commaIndex) else withoutGrouping
        val fractionPart = if (commaIndex >= 0) withoutGrouping.substring(commaIndex + 1) else ""
        val integerDigits = integerPart.filter { it.isDigit() }
        val fractionDigits = fractionPart.filter { it.isDigit() }.take(2)
        if (integerDigits.isEmpty() && fractionDigits.isEmpty()) return null
        val reais = integerDigits.ifEmpty { "0" }.toLongOrNull() ?: return null
        val cents = fractionDigits.padEnd(2, '0').toLongOrNull() ?: 0
        val value = reais * 100 + cents
        return if (negative) -value else value
    }

    private fun groupThousands(value: String): String {
        if (value.length <= 3) return value
        val builder = StringBuilder()
        val firstGroup = value.length % 3
        if (firstGroup > 0) {
            builder.append(value, 0, firstGroup)
            builder.append('.')
        }
        var index = firstGroup
        while (index < value.length) {
            builder.append(value, index, index + 3)
            index += 3
            if (index < value.length) builder.append('.')
        }
        return builder.toString()
    }
}
